export const capitalizeFirstLetter = (str?: string | null) => {
  return !!str && str.length > 0
    ? str.charAt(0).toUpperCase() + str.slice(1)
    : str;
};

export const sanitizeToKey = (str: string | null) => {
  return str?.replace(/[-/ ]/g, "_").toLowerCase() || "";
};

const replacementStrings = [
  ["hiv", "HIV"],
  ["tb", "TB"],
  ["sti", "STI"],
  ["stis", "STIs"],
  ["tpt", "TPT"],
  ["pep", "PEP"],
  ["prep", "PrEP"],
  ["vmmc", "VMMC"],
  ["uti", "UTI"],
  ["arv", "ARV"],
  ["arvs", "ARVs"],
  ["art", "ART"],
];

export const computeReadableValue = (value: string) => {
  if (value === "[]") {
    value = "none";
  }
  // Insert spaces between camelCase and PascalCase words
  value = value
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2");
  replacementStrings.forEach((item: string[]) => {
    value = value.replace(
      new RegExp(`(\\b|_)${item[0]}(\\b|_)`, "g"),
      `$1${item[1]}$2`
    );
  });
  return capitalizeFirstLetter(
    value
      .replace(/(\d+)_(\d+)/g, "$1-$2")
      .replace(/_/g, " ")
      .replace(/[[\]']/g, "")
      .trim()
  );
};

export const GROUP_DISPLAY_NAME_MAP: Record<string, string> = {
  "2025-02-SouthAfrica-clover-FieldStudy": "Aimee Field Study",
  "2025-04-Zimbabwe-celosia-UsabilityStudy": "VimbAI Usability Study",
  "2025-09-Zimbabwe-celosia-FieldStudy": "VimbAI Field Study",
  "2025-04-SouthAfrica-mangrove-UsabilityStudy": "Coach Mpilo Usability Study",
  "2025-09-SouthAfrica-mangrove-FieldStudy": "Coach Mpilo Field Study",
  "2025-04-SouthAfrica-protea": "Self-Cav",

  "2025-02-SouthAfrica-clover-FieldStudy-demo": "Aimee DEMO",
  "2025-04-Zimbabwe-celosia-UsabilityStudy-demo": "VimbAI Usability DEMO",
  "2025-04-SouthAfrica-mangrove-UsabilityStudy-demo": "Coach Mpilo Usability DEMO",
  "2025-09-SouthAfrica-mangrove-FieldStudy-demo": "Coach Mpilo Field DEMO",
  "2025-09-Zimbabwe-celosia-FieldStudy-demo": "VimbAI Field DEMO",
  "2025-04-SouthAfrica-protea-demo": "Self-Cav DEMO",

  ndoh_bwise: "bWise | loveLife DEMO",
  shout: "Shout-It-Now DEMO",
  wrhi_sister_unathi: "Wits RHI DEMO",
  aurum: "Aurum DEMO",
  hivsa: "HIVSA (CHOMA) DEMO",
  chaps: "CHAPS DEMO",
  higher_health: "Higher Health DEMO",
  ommeya: "Ommeya Health DEMO",
  GUUD: "GUUD",

  bwise: "bWise | loveLife",
  shout_non_demo: "Shout-It-Now",
  wrhi: "Wits RHI",
  aurum_non_demo: "Aurum",
  hivsa_non_demo: "HIVSA (CHOMA)",
  chaps_non_demo: "CHAPS",
  higher_health_non_demo: "Higher Health",
  ommeya_non_demo: "Ommeya Health",

  "2024-10-SouthAfrica-In": "Audere DEMO",
  "2024-09-SouthAfrica-Au": "Audere DEMO",
};

export const getDisplayName = (originalName: string) => {
  return GROUP_DISPLAY_NAME_MAP[originalName] || originalName;
};

export const FICUS_PROGRAM_MAP: Record<string, string> = {
  mangrove: "Coach Mpilo",
  protea: "Self-Cav",
  celosia: "VimbAI",
};

const TEMPLATES_WITH_FICUS_PROGRAM = [
  "clinical_portal_request_for_feedback_en",
  "clinical_portal_request_for_feedback_zu",
  "clinical_portal_request_for_feedback_sn",
  "clinical_portal_request_for_feedback_nd",
];

export const getTemplateInterpolation = (
  patientGroup: string,
  template: string
) => {
  if (!patientGroup || !TEMPLATES_WITH_FICUS_PROGRAM.includes(template))
    return {};

  const key = Object.keys(FICUS_PROGRAM_MAP).find((k) =>
    patientGroup.toLowerCase().includes(k)
  );

  return key ? { ficus_program: FICUS_PROGRAM_MAP[key] } : {};
};
